import { render, staticRenderFns } from "./edit-profile-client-form.vue?vue&type=template&id=17f8785e&"
import script from "./edit-profile-client-form.vue?vue&type=script&lang=js&"
export * from "./edit-profile-client-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFormLabel: require('@chakra-ui/vue').CFormLabel, CInput: require('@chakra-ui/vue').CInput, CInputGroup: require('@chakra-ui/vue').CInputGroup, CFormHelperText: require('@chakra-ui/vue').CFormHelperText, CFormControl: require('@chakra-ui/vue').CFormControl, CSelect: require('@chakra-ui/vue').CSelect, CText: require('@chakra-ui/vue').CText, CInputRightElement: require('@chakra-ui/vue').CInputRightElement, CButton: require('@chakra-ui/vue').CButton, CBox: require('@chakra-ui/vue').CBox})
